export function newsletter() {
    setTimeout(() => {
        $('.custom-footer > div:has(.newsletter)')
            .removeClass('col-lg-3')
            .removeClass('col-sm-6')
            .insertBefore('#dklab_instagram_widget')
    }, 100)
}
